export default function EmptyStateCard({ message, buttonText, onClick }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center space-y-4 bg-gray-50 rounded-xl shadow-inner">
      <p className="text-gray-600 text-lg font-medium">{message}</p>
      <button
        onClick={onClick}
        className="px-6 py-2 bg-blue-500 hover:bg-blue-600 text-white text-sm font-medium rounded-lg shadow-md transition"
      >
        {buttonText}
      </button>
    </div>
  );
}
